var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1012"
  }, /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    id: "Ellipse 8",
    d: "M14.1038 7.19509C14.1038 10.9022 11.161 13.8902 7.5519 13.8902C3.94282 13.8902 1 10.9022 1 7.19509C1 3.48797 3.94282 0.5 7.5519 0.5C11.161 0.5 14.1038 3.48797 14.1038 7.19509Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M8.44832 4.40001C8.54722 4.25201 8.6 4.078 8.6 3.9C8.6 3.66131 8.50518 3.43239 8.3364 3.2636C8.16761 3.09482 7.93869 3 7.7 3C7.522 3 7.34799 3.05278 7.19999 3.15168C7.05198 3.25057 6.93663 3.39113 6.86851 3.55558C6.80039 3.72004 6.78257 3.901 6.81729 4.07558C6.85202 4.25016 6.93774 4.41053 7.0636 4.5364C7.18947 4.66226 7.34984 4.74798 7.52442 4.78271C7.699 4.81743 7.87996 4.79961 8.04441 4.73149C8.20887 4.66337 8.34943 4.54802 8.44832 4.40001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M8.54853 6.35147C8.77357 6.57651 8.9 6.88174 8.9 7.2V9.3V11.4H7.7V7.2H6.5V6H7.7C8.01826 6 8.32348 6.12643 8.54853 6.35147Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/infoCircle.7e2f10cdb890cb4f3678dc1c0b430c13.svg";
export { ForwardRef as ReactComponent };